import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const TooltipContainer = ({ position, children, headText }) => (
  <S.Container position={position}>
    {!!headText && <S.Head>{headText}</S.Head>}
    <S.Content>{children}</S.Content>
  </S.Container>
);

export default TooltipContainer;

TooltipContainer.defaultProps = {
  position: 'right',
  headText: '',
};

TooltipContainer.propTypes = {
  position: PropTypes.string,
  headText: PropTypes.string,
  children: PropTypes.node.isRequired,
};
